import Loading from "shared/components/Spin";
import { TEMPLATES } from "utils/constants";
import CollectionNeeds from "./CollectionNeeds";
import Comparison from "./Comparison";
import Contact from "./Contact";
import Contract from "./Contract";
import Default from "./Default";
import Quote from "./Quote";
import SelectProducts from "./SelectProducts";
import Subscription from "./Subscription";

const Templates = {
  Loading: Loading,
  [TEMPLATES.B2B.THEMES.B2B_ACORIS.CONTACT]: Contact,
  [TEMPLATES.B2B.THEMES.B2B_ACORIS.CONTRACT]: Contract,
  [TEMPLATES.B2B.THEMES.B2B_ACORIS.QUOTE]: Quote,
  [TEMPLATES.B2B.THEMES.B2B_ACORIS.COLLECTION_NEEDS]: CollectionNeeds,
  [TEMPLATES.B2B.THEMES.B2B_ACORIS.SELECT_PRODUCTS]: SelectProducts,
  [TEMPLATES.B2B.THEMES.B2B_ACORIS.COMPARISON]: Comparison,
  [TEMPLATES.B2B.THEMES.B2B_ACORIS.SUBSCRIPTION]: Subscription,
  [TEMPLATES.B2B.THEMES.B2B_ACORIS.UPSELLS]: Subscription,
  default: Default,
};
export default Templates;
